import React, { Component } from 'react';
import { connect } from 'react-redux';
import { OTPActions } from '../../Actions';
import Loading from '../../Loading';
import './Telco.css'
class Telco extends Component {

    state = {
        generatedOTP: "",
        showMobileNumber: true,
        isActive: false,
        checkError: {}
    }

    handleCheck = event => {
        const isActive = event.target.checked;
        this.setState({ isActive });
    }

    close = () => {
        window.close();

    }

    generateOTP = (app_id, mobile_num, token, user_id, err) => {
        const { checkError, isActive, generatedOTP } = this.state;
        if (isActive == false && generatedOTP.length) {
            checkError['Terms_and_Condition'] = "Please Accept Terms and Condition";
        } else {
            checkError['Terms_and_Condition'] = "";
        }
        if (Object.values(checkError).some(e => e != "")) {
            this.setState({ checkError })
            return
        }
        if (Object.values(err).some(e => e != "")) {
            return
        }

        if (generatedOTP.length) {
            const { Telco } = this.props;
            this.props.postVerifyOTP({
                "loan_application_id": app_id,
                "mobile_number": mobile_num,
                "otp": generatedOTP,
                "user_id": user_id,
                "request_id": Telco.getResult && Telco.getResult.data && Telco.getResult.data.request_id
            }, token)
            this.setState({ showMobileNumber: false, isActive: false, checkError: {} })
        } else {
            this.props.postOTP({
                "loan_application_id": app_id,
                "mobile_number": mobile_num,
                "user_id": user_id
            }, token);
        }
        this.setState({ generatedOTP: "" })
    }

    render() {
        const { generatedOTP, showMobileNumber, isActive, checkError } = this.state;
        const { Telco } = this.props;
        let search = window.location.search;
        const Application_id = search.slice(search.indexOf('loan_application_id'), search.indexOf('&')).split('=')[1]
        let params = new URLSearchParams(search);
        let mobile_number = params.get('mobile_number');
        let TOKEN = 'Bearer '.concat(params.get('token'));
        const USER_ID = params.get('user_id');
        let check_mobile_number = mobile_number.match(/^\d{10}$/g);
        let error = {};
        if (check_mobile_number) {
            error['mobile_number'] = '';
        } else {
            error['mobile_number'] = 'Mobile number format is invalid';
        }
        const checkTelcoVerified = Telco && Telco.postResult && Telco.postResult.data && Telco.postResult.data.is_verified;
        const checkTelcoError = Telco && Telco.postResult && Telco.postResult.error && Object.values(Telco.postResult.error).some(e => e != "");
        return (
            <div className="container-fluid padd0">
                <div className="col-md-12 d-flex">
                    <div className="col-md-6 p-0">
                        <img src="https://mintifi.com/media/logo.png" alt="logo" className="pt-4 mb-4" />
                    </div>
                </div>
                {
                    showMobileNumber &&
                    <>
                        <div className="col-md-12 mt-4">
                            <div>
                                <div className="text-center">
                                    <span><span className="heading itrColor">Mobile Number </span><label className="heading">Verification</label></span>
                                </div>
                                <div className="text-content mt-3 winText">
                                    <p className="mb-0">Please generate and enter the OTP as sent by your telecom operator </p>
                                    <p className="mb-0">so that your mobile number can be verified by Mintifi Private Limited. </p>
                                    <p className="mb-0">Your data is protected with the highest security standards</p>
                                    <p> and will be shared across lenders associated with your loan application ID - {Application_id}</p>
                                </div>
                                <div className="text-content mt-3 mobText">
                                    <p className="mb-0">Please generate and enter the OTP</p>
                                    <p className="mb-0">as sent by your telecom operator so that your mobile number</p>
                                    <p className="mb-0"> can be verified by Mintifi Private Limited.</p>
                                    <p className="mb-0"> Your data is protected with the highest security standards</p>
                                    <p className="mb-0"> and will be shared across lenders</p>
                                    <p className="mb-0">  associated with your loan application ID -  {Application_id}</p>
                                </div>
                            </div>
                            <div className="col-md-12 padd0">
                                <div className="mrgn80">
                                    <div className="col-md-3 m-auto padd0">
                                        <p className="mb-0 telcoLabel mb-3">Phone Number</p>
                                        <div className="telcoPhoneInput pl-3 pr-3">
                                            <div className="d-flex" style={{ paddingTop: 17 }}>
                                                <img src="/images/flag.png" alt="logo" width="30px" height="20px" className="mr-2" />
                                                <p className="ind mr-2" style={{ paddingTop: 3 }}>India</p>
                                                <p className="code mr-2" style={{ paddingTop: 2 }}>+91</p>
                                            </div>
                                            <div className="divider" />
                                            <input type="text" placeholder="CEAPR1448M" className="col-md-12 phoneInput" value={mobile_number} readOnly />
                                            {error.mobile_number && error.mobile_number.length && (
                                                <span style={{ color: "crimson", fontSize: "16px" }}>
                                                    {error.mobile_number}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-3 m-auto padd0 ">
                                        <p className="mb-0 mt-5 telcoOtpLabel mb-3">OTP</p>
                                        <div className="d-flex mb-2">
                                            <div className="col-md-12 p-0 FlexNone">
                                                <input type="password" placeholder="Enter Your OTP" className="col-md-12 telcoOtpInput" value={generatedOTP} onChange={event => this.setState({ generatedOTP: event.target.value })} />
                                            </div>
                                        </div>
                                        <span className="ml-2"> <img src="/images/info.png" alt="ey" width="15px" className="mr-1" /><span className="telcoOtpLabel">OTP will be sent by your telecom operator </span></span>
                                    </div>
                                    <div className=" mt25">
                                        <div className="col-md-3 m-auto padd0 d-flex mt25">
                                            <input type="checkbox" className="mr-2" onChange={(event) => this.handleCheck(event)} checked={isActive} />
                                            <p className="mb-0 telcoOtpLabel mb-2">I agree to the <a className="term">terms and conditions</a> of Mintifi Private Limited</p>
                                        </div>
                                        <div className="col-md-3 m-auto padd0 d-flex mt25">
                                            {checkError.Terms_and_Condition && checkError.Terms_and_Condition.length && (
                                                <span style={{ color: "crimson", fontSize: "11px", marginLeft: 20 }}>
                                                    {checkError.Terms_and_Condition}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 mt-3 d-flex padd0">
                            <div className="col-md-3 paddlr20 cntr m-auto grid padd0">
                                <button type="button" onClick={() => this.generateOTP(Application_id, mobile_number, TOKEN, USER_ID, error)} className="btnSubmit">{generatedOTP.length ? "Submit" : "Genrate OTP"} <img src="/images/arrow.png" alt="icon" className="ml-3 mb-1 dispNone" /></button>
                            </div>
                        </div>
                    </>
                }
                {
                    Telco.postloading && <Loading />
                }
                {
                    (checkTelcoVerified == true && showMobileNumber == false && Telco.postloading == false) || (showMobileNumber == false && checkTelcoError == false && Telco.postloading == false) ?
                        <>
                            <div className="col-md-12 mrgn52">
                                <div>
                                    <p className="thankyou-inner-text">Your Mobile Number is verified</p>
                                    <h2 className="thankyou-main-text">Thank You!</h2>
                                </div>
                                <div className="col-md-12 mt-5">
                                    <div className="text-center mb-5">
                                        <img src="/images/message popup.png" alt="message" className="imgWidth" style={{ height: 253 }} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 sub-btn mt-3 dispFlex padd0 m-auto">
                                <div className="paddlr20 m-auto grid padd0">
                                    {/* <button className="gst-submit-btn hide-btn-done pl-5 pr-5" onClick={this.close}>Done </button>
                                <button className="gst-submit-btn hide-btn-close pl-5 pr-5" onClick={this.close}>Close </button> */}
                                </div>
                            </div>
                        </>
                        : null
                }
                {
                    (checkTelcoVerified == false && showMobileNumber == false && Telco.postloading == false) || (showMobileNumber == false && checkTelcoError == true && Telco.postloading == false) ?
                        <>
                            <div className="col-md-12 mrgn52">
                                <div>
                                    <h2 className="something-wrong-text">Something went wrong</h2>
                                    <p className="something-wrong-inner-text">We could not verify your number</p>
                                </div>
                                <div className="col-md-12 mt-5">
                                    <div className="text-center mb-5">
                                        <img src="/images/eror message.png" alt="error" className="imgWidth" style={{ height: 253 }} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 mt-3 sub-btn d-flex padd0">
                                <div className="col-md-3 paddlr20 cntr m-auto grid padd0">
                                    <button type="button" className="pl-5 pr-5 btnSubmit" onClick={() => this.setState({ showMobileNumber: true })}> <span>Retry</span><img src="/images/arrow.png" alt="icon" className="ml-3 btnArr" /></button>
                                </div>
                            </div>
                        </>
                        : null
                }
            </div>
        )
    }
}

function mapState(state) {
    const { Telco } = state;
    return { Telco };
}

const actionCreators = {
    postOTP: OTPActions.postOTP,
    postVerifyOTP: OTPActions.postVerifyOTP
};

export default connect(mapState, actionCreators)(Telco);